var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _g, _circle, _g2, _g3, _circle2, _g4, _g5, _circle3, _g6, _g7, _circle4, _g8, _g9, _circle5, _g0, _g1, _circle6, _g10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeIconLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 616,
    height: 473,
    viewBox: "0 0 616 473",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.604 275.266C45.1586 276.601 48.2748 210.286 60.292 161.773C72.3092 113.261 82.9905 98.128 101.238 87.4458C119.486 76.7636 131.058 75.4289 158.652 97.2376",
    stroke: "white",
    strokeOpacity: 0.75,
    strokeWidth: 2.7027,
    strokeMiterlimit: 10,
    strokeDasharray: "10.3 10.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.859 456.409C222.915 404.841 217.847 126.614 208.946 108.811C200.045 91.0079 169.731 80.2875 158.208 95.9029",
    stroke: "white",
    strokeOpacity: 0.75,
    strokeWidth: 2.6606,
    strokeMiterlimit: 10,
    strokeDasharray: "11.09 11.09"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M383.859 275.266C369.825 224.931 353.15 188.032 326 151.537C298.851 115.041 249.003 82.5512 224.97 78.9903C200.936 75.4294 169.056 77.2085 158.654 96.7932",
    stroke: "white",
    strokeOpacity: 0.75,
    strokeWidth: 2.6606,
    strokeMiterlimit: 10,
    strokeDasharray: "11.09 11.09"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M569.008 455.519C627.001 130.5 578.876 104.084 549.501 84.5006C520.126 64.9174 464.417 93.677 464.417 93.677",
    stroke: "white",
    strokeOpacity: 0.75,
    strokeWidth: 2.6606,
    strokeMiterlimit: 10,
    strokeDasharray: "11.09 11.09"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1611 274.376C64.8099 259.444 82.992 248.117 110.141 249.897C137.29 251.677 209.836 299.744 226.304 454.628",
    stroke: "white",
    strokeOpacity: 0.75,
    strokeWidth: 2.6606,
    strokeMiterlimit: 10,
    strokeDasharray: "10.14 10.14"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M384.304 275.711C403.952 260.779 431.036 249.896 460.856 256.127C490.675 262.358 550.315 299.299 566.782 454.183",
    stroke: "white",
    strokeOpacity: 0.75,
    strokeWidth: 2.6606,
    strokeMiterlimit: 10,
    strokeDasharray: "10.14 10.14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M227.195 451.068C236.06 324.216 252.564 221.858 272.592 169.785C292.62 117.711 345.139 76.7647 369.617 69.6437C394.096 62.5227 454.626 77.9155 466.197 95.4571",
    stroke: "white",
    strokeOpacity: 0.75,
    strokeWidth: 2.9056,
    strokeMiterlimit: 10,
    strokeDasharray: "12.12 12.12"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.858 455.074C238.019 387.375 252.2 347.942 276.596 306.865C289.334 285.418 312.647 253.457 338.906 253.457C365.165 253.457 385.193 275.71 385.193 275.71",
    stroke: "white",
    strokeOpacity: 0.75,
    strokeWidth: 2.6606,
    strokeMiterlimit: 10,
    strokeDasharray: "11.09 11.09"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M383.857 276.601C370.504 169.339 395.429 96.348 427.92 89.2272C460.41 82.1063 465.75 94.1222 465.75 94.1222",
    stroke: "white",
    strokeOpacity: 0.75,
    strokeWidth: 2.6606,
    strokeMiterlimit: 10,
    strokeDasharray: "11.09 11.09"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M224.969 449.733C303.301 295.293 515.599 352.262 567.227 454.183",
    stroke: "white",
    strokeOpacity: 0.75,
    strokeWidth: 2.6606,
    strokeMiterlimit: 10,
    strokeDasharray: "11.09 11.09"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4461_64142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-11-inside-1_4461_64142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1214 258.641C74.2295 253.376 84.2764 239.779 84.2764 223.835C84.2764 203.325 67.649 186.697 47.1382 186.697C26.6273 186.697 10 203.325 10 223.835C10 238.249 18.2113 250.745 30.2112 256.901L45.819 277.711L60.1214 258.641Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.1214 258.641C74.2295 253.376 84.2764 239.779 84.2764 223.835C84.2764 203.325 67.649 186.697 47.1382 186.697C26.6273 186.697 10 203.325 10 223.835C10 238.249 18.2113 250.745 30.2112 256.901L45.819 277.711L60.1214 258.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1214 258.641L59.7718 257.704L59.4972 257.807L59.3214 258.041L60.1214 258.641ZM30.2112 256.901L31.0112 256.301L30.8728 256.116L30.6676 256.011L30.2112 256.901ZM45.819 277.711L45.019 278.311L45.819 279.378L46.619 278.311L45.819 277.711ZM83.2764 223.835C83.2764 239.348 73.5015 252.58 59.7718 257.704L60.4711 259.578C74.9575 254.172 85.2764 240.21 85.2764 223.835H83.2764ZM47.1382 187.697C67.0968 187.697 83.2764 203.877 83.2764 223.835H85.2764C85.2764 202.772 68.2013 185.697 47.1382 185.697V187.697ZM11 223.835C11 203.877 27.1796 187.697 47.1382 187.697V185.697C26.0751 185.697 9 202.772 9 223.835H11ZM30.6676 256.011C18.9883 250.02 11 237.86 11 223.835H9C9 238.639 17.4342 251.47 29.7548 257.79L30.6676 256.011ZM46.619 277.111L31.0112 256.301L29.4112 257.501L45.019 278.311L46.619 277.111ZM59.3214 258.041L45.019 277.111L46.619 278.311L60.9214 259.241L59.3214 258.041Z",
    fill: "white",
    fillOpacity: 0.4,
    mask: "url(#path-11-inside-1_4461_64142)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47.2918,
    cy: 223.776,
    r: 28.45,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4461_64142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.0764 239.474C59.7095 239.474 60.227 238.951 60.227 238.3V225.743H63.2518H63.2568C64.3622 225.743 65.2566 224.83 65.2566 223.703C65.2566 223.057 64.9652 222.483 64.508 222.109L60.5989 218.649V212.888C60.5989 212.216 60.0663 211.668 59.403 211.668H56.9309C56.2727 211.668 55.7351 212.216 55.7351 212.888V214.338L48.7811 208.177C48.0274 207.511 46.912 207.511 46.1583 208.177L30.3712 222.16C29.7431 222.719 29.517 223.616 29.8084 224.415C30.0998 225.21 30.8485 225.743 31.6826 225.743H34.7073V238.3C34.7073 238.951 35.2249 239.474 35.858 239.474H42.6612V230.34C42.6612 229.049 43.6862 228.003 44.9524 228.003H49.987C51.2532 228.003 52.2782 229.049 52.2782 230.34V239.469H59.0764V239.474Z",
    fill: "#0b5fd4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4461_64142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-15-inside-2_4461_64142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.286 439.339C254.395 434.074 264.441 420.477 264.441 404.533C264.441 384.022 247.814 367.395 227.303 367.395C206.792 367.395 190.165 384.022 190.165 404.533C190.165 418.947 198.376 431.443 210.376 437.598L225.984 458.409L240.286 439.339Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.286 439.339C254.395 434.074 264.441 420.477 264.441 404.533C264.441 384.022 247.814 367.395 227.303 367.395C206.792 367.395 190.165 384.022 190.165 404.533C190.165 418.947 198.376 431.443 210.376 437.598L225.984 458.409L240.286 439.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.286 439.339L239.937 438.402L239.662 438.504L239.486 438.739L240.286 439.339ZM210.376 437.598L211.176 436.998L211.038 436.814L210.833 436.709L210.376 437.598ZM225.984 458.409L225.184 459.009L225.984 460.075L226.784 459.009L225.984 458.409ZM263.441 404.533C263.441 420.046 253.667 433.278 239.937 438.402L240.636 440.276C255.123 434.87 265.441 420.908 265.441 404.533H263.441ZM227.303 368.395C247.262 368.395 263.441 384.575 263.441 404.533H265.441C265.441 383.47 248.366 366.395 227.303 366.395V368.395ZM191.165 404.533C191.165 384.575 207.345 368.395 227.303 368.395V366.395C206.24 366.395 189.165 383.47 189.165 404.533H191.165ZM210.833 436.709C199.153 430.718 191.165 418.557 191.165 404.533H189.165C189.165 419.337 197.599 432.168 209.92 438.488L210.833 436.709ZM226.784 457.809L211.176 436.998L209.576 438.198L225.184 459.009L226.784 457.809ZM239.486 438.739L225.184 457.809L226.784 459.009L241.086 439.939L239.486 438.739Z",
    fill: "white",
    fillOpacity: 0.4,
    mask: "url(#path-15-inside-2_4461_64142)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.457,
    cy: 404.474,
    r: 28.45,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4461_64142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.24 420.172C239.874 420.172 240.391 419.649 240.391 418.998V406.441H243.416H243.421C244.526 406.441 245.421 405.528 245.421 404.401C245.421 403.755 245.129 403.181 244.672 402.807L240.763 399.347V393.586C240.763 392.914 240.23 392.366 239.567 392.366H237.095C236.437 392.366 235.899 392.914 235.899 393.586V395.036L228.945 388.875C228.191 388.209 227.076 388.209 226.322 388.875L210.535 402.858C209.907 403.416 209.681 404.313 209.972 405.113C210.264 405.907 211.013 406.441 211.847 406.441H214.871V418.998C214.871 419.649 215.389 420.172 216.022 420.172H222.825V411.038C222.825 409.747 223.85 408.701 225.116 408.701H230.151C231.417 408.701 232.442 409.747 232.442 411.038V420.167H239.24V420.172Z",
    fill: "#0b5fd4"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4461_64142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-3_4461_64142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.171 77.9438C187.279 72.6789 197.326 59.0819 197.326 43.1382C197.326 22.6273 180.699 6 160.188 6C139.677 6 123.05 22.6273 123.05 43.1382C123.05 57.552 131.261 70.0479 143.261 76.2033L158.869 97.0136L173.171 77.9438Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.171 77.9438C187.279 72.6789 197.326 59.0819 197.326 43.1382C197.326 22.6273 180.699 6 160.188 6C139.677 6 123.05 22.6273 123.05 43.1382C123.05 57.552 131.261 70.0479 143.261 76.2033L158.869 97.0136L173.171 77.9438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.171 77.9438L172.822 77.0069L172.547 77.1094L172.371 77.3438L173.171 77.9438ZM143.261 76.2033L144.061 75.6033L143.923 75.4188L143.717 75.3136L143.261 76.2033ZM158.869 97.0136L158.069 97.6136L158.869 98.6803L159.669 97.6136L158.869 97.0136ZM196.326 43.1382C196.326 58.651 186.551 71.8832 172.822 77.0069L173.521 78.8807C188.007 73.4746 198.326 59.5127 198.326 43.1382H196.326ZM160.188 7C180.147 7 196.326 23.1796 196.326 43.1382H198.326C198.326 22.0751 181.251 5 160.188 5V7ZM124.05 43.1382C124.05 23.1796 140.229 7 160.188 7V5C139.125 5 122.05 22.0751 122.05 43.1382H124.05ZM143.717 75.3136C132.038 69.3226 124.05 57.1624 124.05 43.1382H122.05C122.05 57.9415 130.484 70.7732 142.805 77.0931L143.717 75.3136ZM159.669 96.4136L144.061 75.6033L142.461 76.8034L158.069 97.6136L159.669 96.4136ZM172.371 77.3438L158.069 96.4136L159.669 97.6136L173.971 78.5438L172.371 77.3438Z",
    fill: "white",
    mask: "url(#path-19-inside-3_4461_64142)"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160.34,
    cy: 43.0774,
    r: 28.45,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4461_64142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.618 59.5337C173.278 59.5337 173.818 58.986 173.818 58.304V45.1484H176.971H176.977C178.129 45.1484 179.061 44.1926 179.061 43.0113C179.061 42.3347 178.758 41.7333 178.281 41.3414L174.205 37.7169V31.6814C174.205 30.978 173.65 30.4034 172.959 30.4034H170.381C169.695 30.4034 169.135 30.978 169.135 31.6814V33.201L161.885 26.7467C161.099 26.0486 159.936 26.0486 159.15 26.7467L142.691 41.3951C142.037 41.9803 141.801 42.92 142.105 43.7577C142.409 44.59 143.189 45.1484 144.059 45.1484H147.212V58.304C147.212 58.986 147.752 59.5337 148.412 59.5337H155.505V49.965C155.505 48.6118 156.573 47.5164 157.893 47.5164H163.142C164.462 47.5164 165.531 48.6118 165.531 49.965V59.5283H172.618V59.5337Z",
    fill: "#0b5fd4"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4461_64142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-23-inside-4_4461_64142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.746 77.9438C494.855 72.6789 504.901 59.0819 504.901 43.1382C504.901 22.6273 488.274 6 467.763 6C447.252 6 430.625 22.6273 430.625 43.1382C430.625 57.552 438.836 70.0479 450.836 76.2033L466.444 97.0136L480.746 77.9438Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M480.746 77.9438C494.855 72.6789 504.901 59.0819 504.901 43.1382C504.901 22.6273 488.274 6 467.763 6C447.252 6 430.625 22.6273 430.625 43.1382C430.625 57.552 438.836 70.0479 450.836 76.2033L466.444 97.0136L480.746 77.9438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.746 77.9438L480.397 77.0069L480.122 77.1094L479.946 77.3438L480.746 77.9438ZM450.836 76.2033L451.636 75.6033L451.498 75.4188L451.293 75.3136L450.836 76.2033ZM466.444 97.0136L465.644 97.6136L466.444 98.6803L467.244 97.6136L466.444 97.0136ZM503.901 43.1382C503.901 58.651 494.127 71.8832 480.397 77.0069L481.096 78.8807C495.582 73.4746 505.901 59.5127 505.901 43.1382H503.901ZM467.763 7C487.722 7 503.901 23.1796 503.901 43.1382H505.901C505.901 22.0751 488.826 5 467.763 5V7ZM431.625 43.1382C431.625 23.1796 447.805 7 467.763 7V5C446.7 5 429.625 22.0751 429.625 43.1382H431.625ZM451.293 75.3136C439.613 69.3226 431.625 57.1624 431.625 43.1382H429.625C429.625 57.9415 438.059 70.7732 450.38 77.0931L451.293 75.3136ZM467.244 96.4136L451.636 75.6033L450.036 76.8034L465.644 97.6136L467.244 96.4136ZM479.946 77.3438L465.644 96.4136L467.244 97.6136L481.546 78.5438L479.946 77.3438Z",
    fill: "white",
    fillOpacity: 0.4,
    mask: "url(#path-23-inside-4_4461_64142)"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 467.915,
    cy: 43.0784,
    r: 28.45,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_4461_64142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M479.7 58.7764C480.334 58.7764 480.851 58.2536 480.851 57.6027V45.045H483.876H483.881C484.986 45.045 485.881 44.1327 485.881 43.005C485.881 42.3592 485.589 41.7852 485.132 41.411L481.223 37.9512V32.1901C481.223 31.5187 480.69 30.9702 480.027 30.9702H477.555C476.897 30.9702 476.359 31.5187 476.359 32.1901V33.6406L469.405 27.4797C468.651 26.8134 467.536 26.8134 466.782 27.4797L450.995 41.4623C450.367 42.0209 450.141 42.9179 450.432 43.7175C450.724 44.512 451.473 45.045 452.307 45.045H455.331V57.6027C455.331 58.2536 455.849 58.7764 456.482 58.7764H463.285V49.6427C463.285 48.351 464.31 47.3054 465.576 47.3054H470.611C471.877 47.3054 472.902 48.351 472.902 49.6427V58.7713H479.7V58.7764Z",
    fill: "#0b5fd4"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_4461_64142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-27-inside-5_4461_64142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.844 439.339C595.953 434.075 606 420.477 606 404.533C606 384.022 589.373 367.395 568.862 367.395C548.351 367.395 531.724 384.022 531.724 404.533C531.724 418.947 539.935 431.444 551.936 437.599L567.543 458.408L581.844 439.339Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.844 439.339C595.953 434.075 606 420.477 606 404.533C606 384.022 589.373 367.395 568.862 367.395C548.351 367.395 531.724 384.022 531.724 404.533C531.724 418.947 539.935 431.444 551.936 437.599L567.543 458.408L581.844 439.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.844 439.339L581.495 438.402L581.22 438.505L581.044 438.739L581.844 439.339ZM551.936 437.599L552.736 436.999L552.597 436.814L552.392 436.709L551.936 437.599ZM567.543 458.408L566.743 459.008L567.543 460.074L568.343 459.008L567.543 458.408ZM605 404.533C605 420.046 595.225 433.279 581.495 438.402L582.194 440.276C596.681 434.87 607 420.908 607 404.533H605ZM568.862 368.395C588.82 368.395 605 384.575 605 404.533H607C607 383.47 589.925 366.395 568.862 366.395V368.395ZM532.724 404.533C532.724 384.575 548.903 368.395 568.862 368.395V366.395C547.799 366.395 530.724 383.47 530.724 404.533H532.724ZM552.392 436.709C540.712 430.718 532.724 418.558 532.724 404.533H530.724C530.724 419.337 539.158 432.169 551.479 438.489L552.392 436.709ZM568.343 457.808L552.736 436.999L551.136 438.199L566.743 459.008L568.343 457.808ZM581.044 438.739L566.743 457.808L568.343 459.008L582.644 439.939L581.044 438.739Z",
    fill: "white",
    fillOpacity: 0.4,
    mask: "url(#path-27-inside-5_4461_64142)"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 569.014,
    cy: 404.686,
    r: 28.45,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_4461_64142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.293 421.141C581.953 421.141 582.493 420.593 582.493 419.911V406.756H585.646H585.651C586.804 406.756 587.736 405.8 587.736 404.619C587.736 403.942 587.432 403.341 586.956 402.949L582.88 399.324V393.289C582.88 392.585 582.325 392.011 581.634 392.011H579.056C578.37 392.011 577.81 392.585 577.81 393.289V394.808L570.56 388.354C569.774 387.656 568.611 387.656 567.825 388.354L551.366 403.002C550.711 403.588 550.476 404.527 550.78 405.365C551.083 406.197 551.864 406.756 552.733 406.756H555.887V419.911C555.887 420.593 556.427 421.141 557.087 421.141H564.179V411.572C564.179 410.219 565.248 409.124 566.568 409.124H571.817C573.137 409.124 574.206 410.219 574.206 411.572V421.136H581.293V421.141Z",
    fill: "#0b5fd4"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_4461_64142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-31-inside-6_4461_64142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.255 258.641C413.363 253.376 423.41 239.779 423.41 223.835C423.41 203.325 406.783 186.697 386.272 186.697C365.761 186.697 349.134 203.325 349.134 223.835C349.134 238.249 357.345 250.745 369.345 256.901L384.953 277.711L399.255 258.641Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M399.255 258.641C413.363 253.376 423.41 239.779 423.41 223.835C423.41 203.325 406.783 186.697 386.272 186.697C365.761 186.697 349.134 203.325 349.134 223.835C349.134 238.249 357.345 250.745 369.345 256.901L384.953 277.711L399.255 258.641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.255 258.641L398.906 257.704L398.631 257.807L398.455 258.041L399.255 258.641ZM369.345 256.901L370.145 256.301L370.007 256.116L369.801 256.011L369.345 256.901ZM384.953 277.711L384.153 278.311L384.953 279.378L385.753 278.311L384.953 277.711ZM422.41 223.835C422.41 239.348 412.635 252.58 398.906 257.704L399.605 259.578C414.091 254.172 424.41 240.21 424.41 223.835H422.41ZM386.272 187.697C406.231 187.697 422.41 203.877 422.41 223.835H424.41C424.41 202.772 407.335 185.697 386.272 185.697V187.697ZM350.134 223.835C350.134 203.877 366.313 187.697 386.272 187.697V185.697C365.209 185.697 348.134 202.772 348.134 223.835H350.134ZM369.801 256.011C358.122 250.02 350.134 237.86 350.134 223.835H348.134C348.134 238.639 356.568 251.47 368.889 257.79L369.801 256.011ZM385.753 277.111L370.145 256.301L368.545 257.501L384.153 278.311L385.753 277.111ZM398.455 258.041L384.153 277.111L385.753 278.311L400.055 259.241L398.455 258.041Z",
    fill: "white",
    fillOpacity: 0.4,
    mask: "url(#path-31-inside-6_4461_64142)"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 386.272,
    cy: 223.836,
    r: 28.45,
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_4461_64142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M398.703 240.232C399.363 240.232 399.903 239.684 399.903 239.002V225.847H403.056H403.062C404.214 225.847 405.146 224.891 405.146 223.71C405.146 223.033 404.843 222.432 404.366 222.04L400.29 218.415V212.38C400.29 211.676 399.735 211.102 399.044 211.102H396.466C395.78 211.102 395.22 211.676 395.22 212.38V213.899L387.97 207.445C387.184 206.747 386.021 206.747 385.235 207.445L368.776 222.093C368.122 222.679 367.886 223.618 368.19 224.456C368.494 225.288 369.274 225.847 370.144 225.847H373.297V239.002C373.297 239.684 373.837 240.232 374.497 240.232H381.589V230.663C381.589 229.31 382.658 228.215 383.978 228.215H389.227C390.547 228.215 391.616 229.31 391.616 230.663V240.227H398.703V240.232Z",
    fill: "#0b5fd4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4461_64142",
    x: 0,
    y: 180.697,
    width: 94.2764,
    height: 111.014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4461_64142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4461_64142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4461_64142",
    x: 180.165,
    y: 361.395,
    width: 94.2764,
    height: 111.014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4461_64142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4461_64142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4461_64142",
    x: 113.05,
    y: 0,
    width: 94.2764,
    height: 111.014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4461_64142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4461_64142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4461_64142",
    x: 420.625,
    y: 0,
    width: 94.2764,
    height: 111.014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4461_64142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4461_64142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_4461_64142",
    x: 521.724,
    y: 361.395,
    width: 94.2764,
    height: 111.013,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4461_64142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4461_64142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_4461_64142",
    x: 339.134,
    y: 180.697,
    width: 94.2764,
    height: 111.014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4461_64142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4461_64142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4461_64142",
    x1: 145.082,
    y1: 79.9473,
    x2: -0.131593,
    y2: 134.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4461_64142",
    x1: 217.74,
    y1: 88.3515,
    x2: 120.066,
    y2: 99.9671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4461_64142",
    x1: 356.835,
    y1: 77.5146,
    x2: 143.114,
    y2: 234.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4461_64142",
    x1: 580.446,
    y1: 77.6714,
    x2: 396.75,
    y2: 119.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4461_64142",
    x1: 204.566,
    y1: 249.712,
    x2: 4.70936,
    y2: 364.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4461_64142",
    x1: 544.885,
    y1: 254.337,
    x2: 346.822,
    y2: 371.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4461_64142",
    x1: 437.517,
    y1: 67.8637,
    x2: 136.57,
    y2: 189.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4461_64142",
    x1: 366.073,
    y1: 253.457,
    x2: 181.125,
    y2: 348.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4461_64142",
    x1: 455.482,
    y1: 86.9717,
    x2: 340.03,
    y2: 120.678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4461_64142",
    x1: 526.156,
    y1: 354.477,
    x2: 441.684,
    y2: 542.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4461_64142",
    x1: 75.3632,
    y1: 186.697,
    x2: -9.6829,
    y2: 231.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4461_64142",
    x1: 60.9877,
    y1: 207.678,
    x2: 26.8087,
    y2: 232.419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4461_64142",
    x1: 255.528,
    y1: 367.395,
    x2: 170.482,
    y2: 412.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4461_64142",
    x1: 241.152,
    y1: 388.375,
    x2: 206.973,
    y2: 413.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4461_64142",
    x1: 188.413,
    y1: 5.99999,
    x2: 103.367,
    y2: 50.9059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4461_64142",
    x1: 174.611,
    y1: 26.2231,
    x2: 138.859,
    y2: 51.9778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4461_64142",
    x1: 495.988,
    y1: 5.99999,
    x2: 410.942,
    y2: 50.906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4461_64142",
    x1: 481.612,
    y1: 26.98,
    x2: 447.433,
    y2: 51.7211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4461_64142",
    x1: 597.087,
    y1: 367.395,
    x2: 512.041,
    y2: 412.301,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4461_64142",
    x1: 583.286,
    y1: 387.831,
    x2: 547.534,
    y2: 413.585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_4461_64142",
    x1: 414.497,
    y1: 186.697,
    x2: 329.451,
    y2: 231.603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_4461_64142",
    x1: 400.696,
    y1: 206.921,
    x2: 364.944,
    y2: 232.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#5755F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519018,
    stopColor: "#4B9EEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#61D395"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4461_64142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5788,
    height: 31.7939,
    fill: "white",
    transform: "translate(29.6826 207.681)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4461_64142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5788,
    height: 31.7939,
    fill: "white",
    transform: "translate(209.847 388.378)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4461_64142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.0928,
    height: 33.3079,
    fill: "white",
    transform: "translate(141.974 26.2261)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4461_64142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.5788,
    height: 31.7939,
    fill: "white",
    transform: "translate(450.307 26.9829)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_4461_64142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.0928,
    height: 33.3079,
    fill: "white",
    transform: "translate(550.648 387.833)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_4461_64142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.0928,
    height: 33.3079,
    fill: "white",
    transform: "translate(368.059 206.924)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeIconLight);
export default __webpack_public_path__ + "static/media/WelcomeIconLight.b8927ff330eb6ac36b5ed74d5ecf6f48.svg";
export { ForwardRef as ReactComponent };